export default __webpack_public_path__ + "static/media/123-doc-p1.f6f5e8f1.jpg";